import { ToggleProps } from '../types';

export const checkToggleTrue = (toggle: ToggleProps): boolean => {
  return Object.entries(toggle).some(([key, value]) => {
    return (
      key !== 'somenteNaoExportados' && key !== 'marcarTodos' && value === true
    );
  });
};
